import React from 'react';
import DownloadLink from './DownloadLink';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Can } from "../../../../_contexts/AbilitiesContext"

export default function CanceledActions({ form }) {
  if (!form.completedAt) {
    return null;
  }

  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/forms/${form.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;

    <DownloadLink form={form} small />
    &nbsp;

    <Can I="send" a="messages">
      <OverlayTrigger placement="top" overlay={<Tooltip>Message</Tooltip>} >
        <Link
          to={{
            state: { patientId: form.patientProfileId },
            pathname: `/messages/view`,
          }}
          className="btn btn-outline-primary btn-sm" ><i className="far fa-comments"></i></Link>
      </OverlayTrigger>
    </Can>
  </div>
}